export default __webpack_public_path__ + "static/trackthebat10-2e733d5bd1bc30626605fa79a2695d0c.jpeg";